import React, { useCallback } from 'react'
import { toast } from 'react-toastify'
import config from '../../config'
import { UploadStyles } from './styled'
import locationApi from '../../utils/locationApi'
import { headers } from './Download'

const url = config.api.baseUrl + '/vehicles'

const Upload = (props) => {
  const handleAddVechicles = useCallback(async (result) => {
    try {
      const newData = result.data.map(d => {
        const rtnDat = {}

        headers.forEach(h => {
          rtnDat[h.key] = d[h.label]
          if (h.key === 'branches') {
            rtnDat[h.key] = rtnDat[h.key].split(',')
          }
        })

        return rtnDat
      })

      await locationApi('post', url, newData)
      toast('Succesfully updated.', {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2500
      })
    } catch (e) {
      toast.error(`Error: ${e}`, {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2500
      })
    }
  }, [])

  const handleSubmit = useCallback((event) => {
    const file = event.target.files[0]
    const Papa = require('papaparse')
    Papa.parse(file, {
      header: true,
      complete: handleAddVechicles
    })
  }, [handleAddVechicles])

  return (
    <UploadStyles>
      <input id='file-upload' type='file' onChange={handleSubmit} />
      <label htmlFor='file-upload'>
        Upload
      </label>
    </UploadStyles>
  )
}

export default Upload
